export default "__VITE_ASSET__jGlszhKj__"